var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 61,
    viewBox: "0 0 34 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23047 42.2274C4.23047 41.1019 4.67755 40.0226 5.47336 39.2268C6.26917 38.431 7.34852 37.9839 8.47396 37.9839H25.4479C26.5734 37.9839 27.6527 38.431 28.4485 39.2268C29.2443 40.0226 29.6914 41.1019 29.6914 42.2274V45.0564C29.6914 46.1818 29.2443 47.2612 28.4485 48.057C27.6527 48.8528 26.5734 49.2999 25.4479 49.2999H8.47396C7.34852 49.2999 6.26917 48.8528 5.47336 48.057C4.67755 47.2612 4.23047 46.1818 4.23047 45.0564V42.2274Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8877 43.6416V43.655Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8877 43.6416V43.655",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 43.6416H24.0334Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 43.6416H24.0334",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23047 30.9115C4.23047 29.786 4.67755 28.7067 5.47336 27.9109C6.26917 27.115 7.34852 26.668 8.47396 26.668H25.4479C26.5734 26.668 27.6527 27.115 28.4485 27.9109C29.2443 28.7067 29.6914 29.786 29.6914 30.9115V33.7405C29.6914 34.8659 29.2443 35.9452 28.4485 36.7411C27.6527 37.5369 26.5734 37.9839 25.4479 37.9839H8.47396C7.34852 37.9839 6.26917 37.5369 5.47336 36.7411C4.67755 35.9452 4.23047 34.8659 4.23047 33.7405V30.9115Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88818 32.3257V32.3391Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88818 32.3257V32.3391",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 32.3257H24.0334Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 32.3257H24.0334",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23047 19.5951C4.23047 18.4696 4.67755 17.3903 5.47336 16.5945C6.26917 15.7986 7.34852 15.3516 8.47396 15.3516H25.4479C26.5734 15.3516 27.6527 15.7986 28.4485 16.5945C29.2443 17.3903 29.6914 18.4696 29.6914 19.5951V22.424C29.6914 23.5495 29.2443 24.6288 28.4485 25.4246C27.6527 26.2205 26.5734 26.6675 25.4479 26.6675H8.47396C7.34852 26.6675 6.26917 26.2205 5.47336 25.4246C4.67755 24.6288 4.23047 23.5495 4.23047 22.424V19.5951Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88818 21.0098V21.0232Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88818 21.0098V21.0232",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 21.0098H24.0334Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 21.0098H24.0334",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23047 8.27962C4.23047 7.15418 4.67755 6.07483 5.47336 5.27902C6.26917 4.48321 7.34852 4.03613 8.47396 4.03613H25.4479C26.5734 4.03613 27.6527 4.48321 28.4485 5.27902C29.2443 6.07483 29.6914 7.15418 29.6914 8.27962V11.1086C29.6914 12.2341 29.2443 13.3134 28.4485 14.1092C27.6527 14.905 26.5734 15.3521 25.4479 15.3521H8.47396C7.34852 15.3521 6.26917 14.905 5.47336 14.1092C4.67755 13.3134 4.23047 12.2341 4.23047 11.1086V8.27962Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88818 9.69385V9.70729Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88818 9.69385V9.70729",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 9.69385H24.0334Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 9.69385H24.0334",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2099,
    y: 0.642031,
    width: 31.502,
    height: 52.0531,
    rx: 6.99802,
    stroke: "black",
    strokeWidth: 1.12
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88872 52.9709V53.7861C8.88872 57.0977 6.20415 59.7823 2.89258 59.7823V59.7823",
    stroke: "black",
    strokeWidth: 1.12
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0156 52.7979V53.7865C25.0156 57.0981 27.7001 59.7827 31.0117 59.7827V59.7827",
    stroke: "black",
    strokeWidth: 1.12
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88867 55.7393L25.0155 55.7393",
    stroke: "black",
    strokeWidth: 1.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRack3);
export default __webpack_public_path__ + "static/media/rack3.bac1bea24745f6c4614ced5544ff7a87.svg";
export { ForwardRef as ReactComponent };